import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the PorRegistroPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'porRegistro',
})
export class PorRegistroPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: Array<Date>, orderBy: string, asc: boolean = true) {
    if (!orderBy || orderBy.trim() == "") {
      return value;
    }

    if (asc) {
      return Array.from(value).sort((itemA: Date, itemB: Date) => {
        return this.orderByComparator(itemA[orderBy], itemB[orderBy]);
      });
    }
    else {
      return Array.from(value).sort((itemA: Date, itemB: Date) => {
        return this.orderByComparator(itemB[orderBy], itemA[orderBy]);
      });
    }
  }

  orderByComparator(a: any, b: any): number {

    if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
      //Isn't a number so lowercase the string to properly compare
      if (a.toLowerCase() < b.toLowerCase()) return -1;
      if (a.toLowerCase() > b.toLowerCase()) return 1;
    }
    else {
      //Parse strings as numbers to compare properly
      if (parseFloat(a) < parseFloat(b)) return -1;
      if (parseFloat(a) > parseFloat(b)) return 1;
    }

    return 0; //equal each other
  }
}



// WEBPACK FOOTER //
// ./src/pipes/por-registro.ts